module.exports = __webpack_public_path__ + "img/game-end-symbol.5af317bb.svg";